<script>
import useSharedData from "@/use/SharedData.js";
import useTools from "@/use/Tools.js";
import {useSecurityStore} from "@/stores/Security.js"
import {computed, onMounted, ref, watch} from "vue";
import useSharedMethod from "@/use/SharedMethod.js";
import {useTrainingRequestStore} from "@/stores/Training/TrainingRequest.js";
import TrainingRequestFilter from "@/views/Training/TrainingRequest/Components/TrainingRequestFilter.vue";
import axios from "axios";
import {storeToRefs} from "pinia";

export default {
    name: "TrainingRequests",
    props: {
        isPlan: Boolean,
        intranet: {
            type: Boolean,
            default: false
        },
    },
    components: {TrainingRequestFilter},
    setup(props) {
        const {
            loading,
            total,
            itemsPerPage,
            filter,
        } = useSharedData();
        
        const {
            formatedDate,
            priceFormat,
            getTrainingRequestPeriodName,
            transformFilterValues
        } = useSharedMethod();
        
        const {$router, $route, $i18n} = useTools();
        
        const trainingRequestStore = useTrainingRequestStore();
        const securityStore = useSecurityStore();
        
        
        const rootPath = computed(() => {
            if (props.isPlan) {
                return "training_plan_details";
            } else if (props.intranet) {
                return "intranet_training_requests";
            }
            return 'training_requests'
        });
        
        let headers = [
            {
                text: "...",
                sortable: false,
                align: "left",
                value: "action",
                width: "0%",
                groupable: false,
            },
            {
                text: $i18n.t("common.code"),
                align: "start",
                sortable: true,
                value: "code",
                width: "0%",
                groupable: false,
            },
            {
                text: $i18n.t("training.theme"),
                align: "start",
                sortable: true,
                value: "catalogName",
                width: "0%",
                groupable: true,
            },
            {
                text: $i18n.t("training.department"),
                align: "start",
                sortable: true,
                value: "organizationalChartName",
                width: "0%",
                groupable: true,
            },
            {
                text: $i18n.t("recruitment_request.applicant"),
                align: "left",
                value: "workerLastName",
                sortable: true,
                groupable: true,
                width: "0%"
            },
            {
                text: $i18n.t("training.period"),
                align: "start",
                sortable: true,
                value: "period",
                width: "0%",
                groupable: false,
            },
            {
                text: $i18n.t("module.training_plan"),
                align: "start",
                sortable: true,
                value: "planName",
                width: "0%",
                groupable: false,
            },
            {
                text: $i18n.t("training.workers_number"),
                align: "start",
                sortable: false,
                value: "workers",
                width: "10%",
                groupable: false,
            },
            {
                text: $i18n.t("training.price"),
                align: "start",
                sortable: true,
                value: "price",
                width: "0%",
                groupable: false,
            },
            {
                text: $i18n.t("training.state"),
                align: "start",
                sortable: true,
                value: "trainingStatus",
                width: "0%",
                groupable: false,
            },
            {
                text: $i18n.t("common.validation"),
                align: "start",
                sortable: true,
                value: "validationStatus.lastState",
                width: "0%",
                groupable: false,
            },
            {
                text: $i18n.t("common.validation_date"),
                align: "start",
                sortable: true,
                value: "validationStatus.lastValidationDate",
                width: "0%",
                groupable: false,
            },
            {
                text: $i18n.t("common.next_validator"),
                align: "start",
                sortable: true,
                value: "validationStatus.nextValidator",
                width: "0%",
                groupable: false,
            },
        ];
        
        headers = headers.filter(header => !props.isPlan || (props.isPlan && header.value !== "planName"))
        headers = headers.filter(header => props.isPlan || (!props.isPlan && header.value !== "catalogPrice" && header.value !== "price" && header.value !== "setDecision"))
        
        const actions = [
            {
                title: $i18n.t("common.validation_history"),
                icon: 'mdi-chart-timeline',
                color: 'blue',
                access: () => true,
                disabled: () => false,
                func: (item) => {
                    $router.push({
                        name: `${rootPath.value}.timelines`,
                        params: {id: item.id, module: 'TRAINING_REQUEST'}
                    })
                },
            },
            {
                title: $i18n.t("common.edit"),
                icon: 'mdi-pencil-box-multiple',
                color: 'orange',
                access: (item) => item.updateOption,
                disabled: () => false,
                func: (item) => {
                    $router.push({name: `${rootPath.value}.edit`, params: {id: item.id}})
                },
            },
            {
                title: $i18n.t("common.delete"),
                icon: 'mdi-trash-can',
                color: 'red',
                access: (item) => item.deleteOption,
                disabled: () => false,
                func: (item) => {
                    $router.push({name: `${rootPath.value}.delete`, params: {id: item.id}})
                },
            },
            {
                title: $i18n.t("module.edms"),
                icon: 'mdi-folder',
                color: 'amber',
                access: () => true,
                disabled: () => false,
                func: (item) => {
                    $router.push({name: `${rootPath.value}.documents`, params: {id: item.id}})
                },
            },
        ];
        
        const planActions = [
            {
                title: $i18n.t("training.add_to_catalog"),
                icon: 'mdi-plus-circle-outline',
                color: 'teal',
                access: (item) => item.other && item.updateOption,
                disabled: () => false,
                func: (item) => {
                    $router.push({
                        name: `${rootPath.value}.add_to_catalog`,
                        params: {id: item.id, module: 'TRAINING_REQUEST'}
                    })
                },
            },
            {
                title: $i18n.t("module.edms"),
                icon: 'mdi-folder',
                color: 'amber',
                access: () => true,
                disabled: () => false,
                func: (item) => {
                    $router.push({name: `${rootPath.value}.documents`, params: {id: item.id}})
                },
            },
        ];
        
        const {itemsToBeValidate} = storeToRefs(securityStore);
        
        const groupBy = ref("catalogName");
        const searchParams = ref({
            sortBy: "postDateTime",
            descending: true,
            page: 1,
            itemsPerPage: itemsPerPage,
            planId: $route.params.$route,
        });
        
        function handleSearch(params) {
            loading.value = true;
            trainingRequestStore.setTrainingRequests([]);
            total.value = 0;
            
            filter.value.itemsToBeValidate = itemsToBeValidate.value;
            
            filter.value.myData = props.intranet;
            
            filter.value.page = params.page - 1;
            filter.value.rowsPerPage = params.itemsPerPage;
            filter.value.sortBy = params.sortBy;
            filter.value.descending = params.descending;
            
            filter.value.allRecords = props.isPlan;
            
            axios.get('/trainingRequests', {params: transformFilterValues(filter.value)}).then((response) => {
                const elements = response.data.elements.map(i => ({
                    ...i,
                    workerLastName: i.workerLastName ?? i.workerName
                }));
                trainingRequestStore.setTrainingRequests(elements);
                total.value = response.data.total;
            }).finally(() => {
                loading.value = false;
            });
        }
        
        function findAll() {
            handleSearch(searchParams.value)
        }
        
        watch(() => [filter.value, itemsToBeValidate.value], () => {
            searchParams.page = 1;
            findAll();
        }, {deep: true, immediate: true});
        
        watch(searchParams, (newParams) => {
            handleSearch(newParams);
        }, {deep: true});
        
        function clearFilter() {
            Object.keys(filter.value).forEach(key => {
                if (key === 'planId' && props.isPlan) {
                    filter.value[key] = $route.params.planId;
                } else {
                    filter.value[key] = null;
                }
            });
            itemsToBeValidate.value = false;
        }
        
        function view(item) {
            $router.push({
                name: `${props.isPlan ? 'training_plans' : 'training_requests'}.view`,
                params: {id: item.id}
            });
        }
        
        const isOpen = ref(false);
        const isOpenLoading = ref(false);
        
        function existPlanOpen() {
            isOpenLoading.value = true;
            axios.get(`/trainingPlans/existPlanOpen`).then(response => {
                isOpen.value = response.data;
            }).finally(() => {
                isOpenLoading.value = false;
            });
        }
        
        const plan = ref({});
        
        function findPlanById() {
            axios.get(`/trainingPlans/${$route.params.planId}`).then(response => {
                plan.value = response.data;
            });
        }
        
        function calculateTotal(items) {
            let sum = 0;
            items.forEach(item => sum += parseFloat(item.price));
            return sum;
        }
        
        onMounted(() => {
            existPlanOpen();
            if (props.isPlan) {
                findPlanById();
            }
        });
        
        return {
            groupBy,
            trainingRequestStore,
            securityStore,
            headers,
            loading,
            total,
            itemsPerPage,
            filter,
            isOpen,
            isOpenLoading,
            plan,
            searchParams,
            actions,
            planActions,
            rootPath,
            itemsToBeValidate,
            view,
            formatedDate,
            priceFormat,
            findAll,
            clearFilter,
            getTrainingRequestPeriodName,
            calculateTotal
        };
    },
};
</script>

<template>
    <div>
        <w-app
            :title="isPlan ? plan.name : $t('module.training_request')"
            show-total
            :total="total"
            :show-filter="!intranet"
            :filter="filter"
            @clearFilter="clearFilter"
        >
            <template v-slot:filter>
                <TrainingRequestFilter v-model="filter" :is-plan="isPlan"/>
            </template>
            
            <template v-slot:leftToolbar>
                <v-checkbox
                    v-model="itemsToBeValidate"
                    :label="$t('common.requests_need_validation')"
                    :true-value="true"
                    :false-value="false"
                    class="ml-2"
                    hide-details
                />
            </template>
            
            <template v-slot:rightToolbar>
                <w-btn-reload :loading="loading" @press="findAll"/>
                <w-btn-add
                    :show="!isPlan && securityStore.authorities['SAVE_TRAINING_REQUEST']"
                    :disabled="!isOpen"
                    :loading="isOpenLoading"
                    @press="$router.push({ name: `${rootPath}.add` })"
                />
            </template>
            
            <template v-slot:content>
                <w-data-table
                    v-if="isPlan"
                    :headers="headers"
                    :actions="planActions"
                    :items="trainingRequestStore.trainingRequests"
                    :loading="loading"
                    :sort-by="searchParams.sortBy"
                    :descending="searchParams.descending"
                    disable-pagination
                    show-group-by
                    group-by="catalogName"
                    show-validation
                    :root-path="rootPath"
                    module="TRAINING_REQUEST"
                    @rowDbClick="view"
                
                >
                    <template v-slot:group-header="{ group, groupBy, isOpen, items,  toggle }">
                        <td colspan="6">
                            <v-btn icon @click="toggle" v-if="isOpen">
                                <v-icon>mdi-minus</v-icon>
                            </v-btn>
                            <v-btn icon @click="toggle" v-else>
                                <v-icon>mdi-plus</v-icon>
                            </v-btn>
                            <span v-if="groupBy[0] === 'catalogName'">
                                      {{ $t("training.theme") }}: <w-inline-text bold
                                                                                 :text="`${group ? group : $t('common.other')}`"/>
                                    </span>
                            <span v-if="groupBy[0] === 'organizationalChartName'">
                                        {{ $t("training.department") }}: <w-inline-text bold :text="group"/>
                                    </span>
                            <span v-if="groupBy[0] === 'workerLastName'">
                                        {{ $t("recruitment_request.applicant") }}: <w-inline-text bold :text="group"/>
                                    </span>
                        </td>
                        <td>
                            <strong class="teal--text">
                                {{ priceFormat(calculateTotal(items)) }}
                            </strong>
                        </td>
                        <td colspan="6">
                        </td>
                    </template>
                    <template v-slot:[`item.workerCode`]="{ item }">
                        <w-chip :text="item.workerCode"/>
                    </template>
                    <template v-slot:[`item.catalogName`]="{ item }">
                        <w-inline-text :text="item.catalogName"/>
                    </template>
                    <template v-slot:[`item.organizationalChartName`]="{ item }">
                        <w-inline-text :text="item.organizationalChartName"/>
                    </template>
                    <template v-slot:[`item.workerLastName`]="{ item }">
                        <w-inline-text :text="item.workerName"/>
                    </template>
                    <template v-slot:[`item.workers`]="{ item }">
                        <w-chip outlined :text="item.workerIds.length"/>
                    </template>
                    <template v-slot:[`item.period`]="{ item }">
                        <w-inline-text :text="getTrainingRequestPeriodName(item)"/>
                    </template>
                    <template v-slot:[`item.price`]="{ item }">
                        <w-inline-text clazz="teal--text" :text="priceFormat(item.price)"/>
                    </template>
                    <template v-slot:[`item.trainingStatus`]="{ item }">
                        <w-chip color="teal" :text="$t(`training.status_${item.trainingStatus}`)"/>
                    </template>
                </w-data-table>
                <w-server-data-table
                    v-if="!isPlan"
                    v-model="searchParams"
                    :actions="actions"
                    :headers="headers"
                    :items="trainingRequestStore.trainingRequests"
                    :loading="loading"
                    :total="total"
                    :root-path="rootPath"
                    module="TRAINING_REQUEST"
                    @rowDbClick="view"
                >
                    <template v-slot:[`item.code`]="{ item }">
                        <w-chip :text="item.code"/>
                    </template>
                    <template v-slot:[`item.catalogName`]="{ item }">
                        <w-inline-text
                            bold
                            :clazz="item.other ? 'red--text' : ''"
                            :text="item.other ? `${item.otherDescription} (${$t('common.other')})` : item.catalogName"
                        />
                    </template>
                    <template v-slot:[`item.organizationalChartName`]="{ item }">
                        <w-inline-text :text="item.organizationalChartName"/>
                    </template>
                    <template v-slot:[`item.workerLastName`]="{ item }">
                        <w-inline-text :text="item.workerName"/>
                    </template>
                    <template v-slot:[`item.planName`]="{ item }">
                        <w-inline-text :text="item.planName"/>
                    </template>
                    <template v-slot:[`item.workers`]="{ item }">
                        <w-chip outlined :text="item.workerIds.length"/>
                    </template>
                    <template v-slot:[`item.period`]="{ item }">
                        <w-inline-text :text="getTrainingRequestPeriodName(item)"/>
                    </template>
                    <template v-slot:[`item.trainingStatus`]="{ item }">
                        <w-chip color="teal" :text="$t(`training.status_${item.trainingStatus}`)"/>
                    </template>
                </w-server-data-table>
            </template>
        </w-app>
        
        <router-view/>
    </div>
</template>